import React from 'react';

// One block of a project writeup: heading, body text, then a row of figures.
const Section = ({ title, figures = [], children }) => {
  return (
    <section className="project-section">
      {title && <h2>{title}</h2>}
      {children}
      {figures.length > 0 && (
        <div className="project-figures">
          {figures.map((f) => (
            <figure key={f.src}>
              <img src={f.src} alt={f.alt} />
              {f.caption && <figcaption>{f.caption}</figcaption>}
            </figure>
          ))}
        </div>
      )}
    </section>
  );
};

export default Section;
